// Curash Quick-Add Modal v3 — global, opens with window.CurashQuickAdd.open(handle)
(function () {
  // This asset is included by several sections (product page, related-products,
  // new-trending-products). Each include re-runs this IIFE with its own
  // module-scoped element refs. initRefs() bails on the 2nd+ run (modal already
  // wired), leaving those refs undefined — but window.CurashQuickAdd.open would
  // still get overwritten to point at the un-wired instance, throwing
  // "Cannot set properties of undefined" on open. Guard: first instance wins.
  if (window.CurashQuickAdd && window.CurashQuickAdd.open) return;
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function imgSrc(maybeImage) {
    if (!maybeImage) return '';
    var s = typeof maybeImage === 'string' ? maybeImage : (maybeImage.src || '');
    if (!s) return '';
    // protocol-relative → https
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s;
  }
  function colorHex(name) {
    var c = String(name || '').toLowerCase().trim();
    if (c.indexOf('off-white') >= 0 || c.indexOf('off white') >= 0 || c.indexOf('ivory') >= 0) return '#F8F4EA';
    if (c.indexOf('cream') >= 0) return '#F5EFE0';
    if (c.indexOf('champagne') >= 0) return '#F7E7CE';
    if (c.indexOf('white') >= 0 || c.indexOf('snow') >= 0) return '#FFFFFF';
    if (c.indexOf('jet') >= 0 || c.indexOf('onyx') >= 0) return '#0A0A0A';
    if (c.indexOf('black') >= 0 || c.indexOf('noir') >= 0) return '#111111';
    if (c.indexOf('charcoal') >= 0 || c.indexOf('graphite') >= 0 || c.indexOf('slate') >= 0) return '#36454F';
    if (c.indexOf('silver') >= 0) return '#C0C0C0';
    if (c.indexOf('gunmetal') >= 0) return '#2C3539';
    if (c.indexOf('grey') >= 0 || c.indexOf('gray') >= 0) return '#9CA3AF';
    if (c.indexOf('navy') >= 0) return '#1E3A5F';
    if (c.indexOf('royal blue') >= 0 || c.indexOf('cobalt') >= 0) return '#1D4ED8';
    if (c.indexOf('sky') >= 0 || c.indexOf('baby blue') >= 0 || c.indexOf('light blue') >= 0 || c.indexOf('powder blue') >= 0) return '#A4D4F0';
    if (c.indexOf('denim') >= 0 || c.indexOf('indigo') >= 0 || c.indexOf('ink blue') >= 0) return '#3A4F7A';
    if (c.indexOf('teal') >= 0) return '#14B8A6';
    if (c.indexOf('turquoise') >= 0 || c.indexOf('aqua') >= 0) return '#40E0D0';
    if (c.indexOf('blue') >= 0) return '#2563EB';
    if (c.indexOf('crimson') >= 0 || c.indexOf('cherry') >= 0) return '#B91C1C';
    if (c.indexOf('red') >= 0) return '#DC2626';
    if (c.indexOf('burgundy') >= 0 || c.indexOf('wine') >= 0 || c.indexOf('maroon') >= 0 || c.indexOf('merlot') >= 0) return '#722F37';
    if (c.indexOf('rust') >= 0 || c.indexOf('terracotta') >= 0) return '#B7410E';
    if (c.indexOf('hot pink') >= 0 || c.indexOf('magenta') >= 0 || c.indexOf('fuchsia') >= 0) return '#EC4899';
    if (c.indexOf('rose') >= 0 || c.indexOf('blush') >= 0) return '#F9A8B4';
    if (c.indexOf('pink') >= 0) return '#F4C2C2';
    if (c.indexOf('salmon') >= 0) return '#FA8072';
    if (c.indexOf('apricot') >= 0) return '#F2A878';
    if (c.indexOf('coral') >= 0 || c.indexOf('peach') >= 0) return '#FF8C69';
    if (c.indexOf('orange') >= 0 || c.indexOf('tangerine') >= 0) return '#F97316';
    if (c.indexOf('lavender') >= 0 || c.indexOf('lilac') >= 0 || c.indexOf('light purple') >= 0) return '#C4B5FD';
    if (c.indexOf('plum') >= 0) return '#673147';
    if (c.indexOf('purple') >= 0 || c.indexOf('violet') >= 0) return '#7C3AED';
    if (c.indexOf('mint') >= 0) return '#A7E8C7';
    if (c.indexOf('sage') >= 0) return '#9CAF88';
    if (c.indexOf('olive') >= 0) return '#708238';
    if (c.indexOf('forest') >= 0 || c.indexOf('hunter') >= 0 || c.indexOf('emerald') >= 0) return '#065F46';
    if (c.indexOf('green') >= 0 || c.indexOf('lime') >= 0) return '#16A34A';
    if (c.indexOf('mustard') >= 0) return '#D4A017';
    if (c.indexOf('yellow') >= 0) return '#FCD34D';
    if (c.indexOf('gold') >= 0) return '#D4AF37';
    if (c.indexOf('bronze') >= 0 || c.indexOf('copper') >= 0) return '#CD7F32';
    if (c.indexOf('taupe') >= 0) return '#B8A492';
    if (c.indexOf('tan') >= 0 || c.indexOf('sand') >= 0 || c.indexOf('wheat') >= 0 || c.indexOf('camel') >= 0) return '#D2B48C';
    if (c.indexOf('nude') >= 0 || c.indexOf('beige') >= 0 || c.indexOf('skin') >= 0) return '#E8C8A8';
    if (c.indexOf('khaki') >= 0) return '#BDB76B';
    if (c.indexOf('chocolate') >= 0 || c.indexOf('espresso') >= 0) return '#3D2817';
    if (c.indexOf('mocha') >= 0 || c.indexOf('coffee') >= 0 || c.indexOf('cocoa') >= 0) return '#6F4E37';
    if (c.indexOf('brown') >= 0 || c.indexOf('mahogany') >= 0) return '#92400E';
    if (c.indexOf('leopard') >= 0 || c.indexOf('animal') >= 0) return '#A47551';
    if (c.indexOf('multi') >= 0 || c.indexOf('rainbow') >= 0 || c.indexOf('print') >= 0 || c.indexOf('pattern') >= 0) return 'multi';
    return '';
  }
  function ratingFor(productId) {
    var h = Number(productId) || 0;
    var dsum = 0;
    for (var i = 0; i < 12 && h > 0; i++) { dsum += h % 10; h = Math.floor(h / 10); }
    return (((dsum * 7) % 10) + 40) / 10;
  }
  function reviewCountFor(productId) {
    var id = Number(productId) || 0;
    var base = (id % 351) + 50;
    var now = Math.floor(Date.now() / 1000);
    var elapsed = Math.max(0, now - 1749686400);
    var periods = Math.floor(elapsed / 172800);
    var rate = (id % 3) + 2;
    return base + (periods * rate);
  }
  function ratingHTML(productId) {
    var r = ratingFor(productId);
    var pct = r * 20;
    var n = reviewCountFor(productId);
    return '<div class="product-rating product-rating--left product-rating--small">'
      + '<span class="product-rating__stars" aria-label="' + r + ' out of 5 stars">'
      + '<span aria-hidden="true">★★★★★</span>'
      + '<span class="product-rating__stars-fg" style="width: ' + pct + '%;" aria-hidden="true">★★★★★</span>'
      + '</span>'
      + '<span class="product-rating__num">' + r + '</span>'
      + '<span class="product-rating__count">(' + n + ')</span>'
      + '</div>';
  }
  var _moneyFormat = (window.__curashMoneyFormat || '{{amount}}');
  function formatMoney(cents) {
    if (cents == null) return '';
    var amount = (cents / 100).toFixed(2);
    return _moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100)).replace('{{amount_with_comma_separator}}', amount.replace('.', ',')).replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function findVariant(product, selected) {
    var variants = product.variants || [];
    var optNames = product.options || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < optNames.length; j++) {
        if (selected[optNames[j]] !== v['option' + (j + 1)]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  var lastFetchError = '';
  function fetchProduct(handle) {
    lastFetchError = '';
    if (!handle) { lastFetchError = 'no handle'; return Promise.resolve(null); }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) { lastFetchError = 'HTTP ' + res.status; throw new Error(lastFetchError); }
      return res.text().then(function (text) {
        try { return JSON.parse(text); }
        catch (e) {
          lastFetchError = 'response is not JSON (likely the password page returned HTML)';
          throw new Error(lastFetchError);
        }
      });
    }).catch(function (err) {
      console.warn('[QuickAdd] fetchProduct error:', err);
      return null;
    });
  }

  var modalEl, modalImage, modalImageSecondary, modalMedia, modalTitle, modalRating, modalPrice, modalOptions, modalQty, modalAdd, modalStatus;
  var modalAddLabel, modalAddSep, modalAddPrice, modalStock, modalViewFull;
  var modalDefaultView, modalSuccess, modalSuccessImage, modalSuccessTitle, modalSuccessPrice, modalSuccessVariant, modalSuccessSubtotal;
  var modalProduct = null;
  var modalSelected = {};
  var lastHandle = '';

  function renderModal() {
    if (!modalProduct) return;
    var current = findVariant(modalProduct, modalSelected);

    // Primary image: variant's image, else featured, else first
    var imgUrl = '';
    if (current && current.featured_image) imgUrl = imgSrc(current.featured_image);
    if (!imgUrl) imgUrl = imgSrc(modalProduct.featured_image) || ((modalProduct.images || [])[0] || '');
    modalImage.src = imgUrl;
    modalImage.alt = modalProduct.title || '';

    // Secondary image: next image in product.images after the primary (for hover swap)
    var secondaryUrl = '';
    if (imgUrl && modalProduct.images && modalProduct.images.length > 1) {
      // Normalize for comparison: strip protocol and width param
      function normUrl(u) { return String(u || '').replace(/^https?:/, '').replace(/[?&]width=\d+/, ''); }
      var normPrimary = normUrl(imgUrl);
      var idx = -1;
      for (var ii = 0; ii < modalProduct.images.length; ii++) {
        if (normUrl(imgSrc(modalProduct.images[ii])) === normPrimary) { idx = ii; break; }
      }
      if (idx >= 0 && idx + 1 < modalProduct.images.length) {
        secondaryUrl = imgSrc(modalProduct.images[idx + 1]);
      } else if (idx < 0 && modalProduct.images.length > 1) {
        secondaryUrl = imgSrc(modalProduct.images[1]);
      }
    }
    if (modalImageSecondary) {
      if (secondaryUrl) {
        modalImageSecondary.src = secondaryUrl;
        modalImageSecondary.alt = modalProduct.title || '';
        if (modalMedia) modalMedia.classList.add('has-secondary');
      } else {
        modalImageSecondary.removeAttribute('src');
        if (modalMedia) modalMedia.classList.remove('has-secondary');
      }
    }

    modalTitle.textContent = modalProduct.title || '';
    modalRating.innerHTML = ratingHTML(modalProduct.id);

    if (current) {
      var price = formatMoney(current.price);
      var compare = current.compare_at_price > current.price ? formatMoney(current.compare_at_price) : '';
      modalPrice.innerHTML = (compare ? '<del>' + compare + '</del> ' : '') + price;
    } else {
      modalPrice.innerHTML = '';
    }

    var optNames = modalProduct.options || [];
    modalOptions.innerHTML = '';
    optNames.forEach(function (optName, i) {
      var optKey = 'option' + (i + 1);
      var isColor = String(optName).toLowerCase() === 'color' || String(optName).toLowerCase() === 'colour';

      var values = [];
      var seen = {};
      (modalProduct.variants || []).forEach(function (v) {
        var val = v[optKey];
        if (val && !seen[val]) { seen[val] = true; values.push(val); }
      });

      var isSize = String(optName).toLowerCase() === 'size';
      var html = '<div class="qa-modal__option-group">';
      html += '<div class="qa-modal__option-header">';
      html += '<span class="qa-modal__option-label">' + esc(optName) + ': <strong>' + esc(modalSelected[optName] || '') + '</strong></span>';
      if (isSize) html += '<button type="button" class="qa-modal__size-guide" data-qa-size-guide>Size guide</button>';
      html += '</div>';
      html += '<div class="qa-modal__values">';
      values.forEach(function (val) {
        var isSelected = modalSelected[optName] === val;
        var hypothetical = Object.assign({}, modalSelected);
        hypothetical[optName] = val;
        var matched = findVariant(modalProduct, hypothetical);
        var unavailable = matched ? !matched.available : true;

        if (isColor) {
          var hex = colorHex(val);
          var styleStr = hex === 'multi'
            ? 'background: conic-gradient(#F87171, #FBBF24, #34D399, #60A5FA, #A78BFA, #F87171);'
            : (hex ? 'background-color: ' + hex + ';' : 'background-color: #eee;');
          html += '<button type="button" class="qa-modal__swatch'
            + (isSelected ? ' is-selected' : '')
            + (unavailable ? ' is-unavailable' : '') + '"'
            + ' data-qa-option="' + esc(optName) + '" data-qa-value="' + esc(val) + '"'
            + ' style="' + styleStr + '" title="' + esc(val) + '" aria-label="' + esc(val) + '"></button>';
        } else {
          html += '<button type="button" class="qa-modal__value'
            + (isSelected ? ' is-selected' : '')
            + (unavailable ? ' is-unavailable' : '') + '"'
            + ' data-qa-option="' + esc(optName) + '" data-qa-value="' + esc(val) + '">' + esc(val) + '</button>';
        }
      });
      html += '</div></div>';
      modalOptions.insertAdjacentHTML('beforeend', html);
    });

    modalOptions.querySelectorAll('[data-qa-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optName = btn.getAttribute('data-qa-option');
        var val = btn.getAttribute('data-qa-value');
        modalSelected[optName] = val;
        renderModal();
      });
    });

    function setAddButton(label, priceText) {
      if (modalAddLabel) modalAddLabel.textContent = label;
      if (modalAddPrice) modalAddPrice.textContent = priceText || '';
      if (modalAddSep) modalAddSep.style.display = priceText ? '' : 'none';
    }

    if (!current) {
      modalAdd.disabled = true;
      modalAdd.classList.remove('is-success');
      setAddButton('Unavailable', '');
      modalAdd.removeAttribute('data-current-variant');
      modalStatus.textContent = 'This combination is not available';
      if (modalStock) modalStock.style.display = 'none';
    } else if (!current.available) {
      modalAdd.disabled = true;
      modalAdd.classList.remove('is-success');
      setAddButton('Sold out', '');
      modalAdd.removeAttribute('data-current-variant');
      modalStatus.textContent = '';
      if (modalStock) modalStock.style.display = 'none';
    } else {
      modalAdd.disabled = false;
      modalAdd.classList.remove('is-success');
      setAddButton('Add to cart', formatMoney(current.price));
      modalAdd.setAttribute('data-current-variant', current.id);
      modalStatus.textContent = '';
      if (modalStock) modalStock.style.display = '';
    }

    if (modalViewFull && modalProduct && modalProduct.url) {
      modalViewFull.setAttribute('href', modalProduct.url);
    }
  }

  function applyProductToModal(product) {
    modalProduct = product;
    modalSelected = {};
    var first = (product.variants || []).filter(function (v) { return v.available; })[0] || (product.variants || [])[0];
    if (first && product.options) {
      product.options.forEach(function (optName, i) {
        modalSelected[optName] = first['option' + (i + 1)];
      });
    }
    renderModal();
  }

  // Open the size chart that matches the CURRENT product's collections — mirrors
  // the dispatcher on the product page so the popup shows the right chart.
  function openSizeChartForProduct() {
    var cols = (modalProduct && modalProduct.collections) || [];
    var has = function (list) {
      return cols.some(function (h) { return list.indexOf(h) > -1; });
    };
    var dressCols      = ['dresses', 'dresses-2'];
    var activewearCols = ['activewear-bra-legging-top', 'activewear-bras-leggings', 'activewear'];
    var bodysuitCols   = ['bodysuits', 'cinchers'];

    var fn = null;
    if (has(dressCols))           fn = window.__curashSizeChartDresses;
    else if (has(activewearCols)) fn = window.__curashSizeChartActivewear;
    else if (has(bodysuitCols))   fn = window.__curashSizeChartBodysuit;
    // Fallback: if no collection matched, open the first available chart.
    if (!fn) {
      fn = window.__curashSizeChartBodysuit || window.__curashSizeChartActivewear || window.__curashSizeChartDresses;
    }
    if (typeof fn === 'function') {
      // Set the chart heading to this product's title (charts render globally
      // without a product in scope, so the title is otherwise blank).
      if (modalProduct && modalProduct.title) {
        document.querySelectorAll('.curash-size-chart-title, .curash-sc-title, .curash-dr-title').forEach(function (el) {
          el.textContent = modalProduct.title;
        });
      }
      fn();
    }
  }

  function openModal(handle, productData) {
    if (!modalEl) initRefs();
    if (!modalEl) {
      // DOM not ready yet — retry once after a tick
      setTimeout(function () { openModal(handle, productData); }, 50);
      return;
    }
    lastHandle = handle;
    modalEl.setAttribute('data-open', 'true');
    modalEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Reset to default view (in case it was showing success)
    if (modalDefaultView) modalDefaultView.hidden = false;
    if (modalSuccess) modalSuccess.hidden = true;

    modalTitle.textContent = 'Loading…';
    modalImage.src = '';
    modalImage.alt = '';
    if (modalImageSecondary) modalImageSecondary.removeAttribute('src');
    if (modalMedia) modalMedia.classList.remove('has-secondary');
    modalOptions.innerHTML = '';
    modalPrice.innerHTML = '';
    modalRating.innerHTML = '';
    modalStatus.textContent = '';
    modalAdd.disabled = true;
    modalAdd.classList.remove('is-success');
    if (modalAddLabel) modalAddLabel.textContent = 'Add to cart';
    if (modalAddPrice) modalAddPrice.textContent = '';
    if (modalAddSep) modalAddSep.style.display = 'none';
    modalAdd.removeAttribute('data-current-variant');
    if (modalStock) modalStock.style.display = '';
    if (modalQty) modalQty.value = '1';

    // Preferred path: caller passed full product data (avoids AJAX blocked by password gate)
    if (productData && typeof productData === 'object') {
      applyProductToModal(productData);
      return;
    }

    // Fallback: AJAX fetch
    fetchProduct(handle).then(function (product) {
      if (lastHandle !== handle) return;
      if (!product) {
        modalTitle.textContent = 'Could not load product';
        modalStatus.textContent = 'Tried /products/' + handle + '.js — ' + (lastFetchError || 'unknown error');
        return;
      }
      applyProductToModal(product);
    });
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.setAttribute('data-open', 'false');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initRefs() {
    modalEl = document.querySelector('[data-qa-modal]');
    if (!modalEl || modalEl.dataset.wired === '1') return;
    modalEl.dataset.wired = '1';
    modalImage = modalEl.querySelector('[data-qa-image]');
    modalImageSecondary = modalEl.querySelector('[data-qa-image-secondary]');
    modalMedia = modalEl.querySelector('[data-qa-media]');
    modalTitle = modalEl.querySelector('[data-qa-title]');
    modalRating = modalEl.querySelector('[data-qa-rating]');
    modalPrice = modalEl.querySelector('[data-qa-price]');
    modalOptions = modalEl.querySelector('[data-qa-options]');
    modalQty = modalEl.querySelector('[data-qa-qty]');
    modalAdd = modalEl.querySelector('[data-qa-add]');
    modalStatus = modalEl.querySelector('[data-qa-status]');
    modalAddLabel = modalEl.querySelector('[data-qa-add-label]');
    modalAddSep = modalEl.querySelector('[data-qa-add-sep]');
    modalAddPrice = modalEl.querySelector('[data-qa-add-price]');
    modalStock = modalEl.querySelector('[data-qa-stock]');
    modalViewFull = modalEl.querySelector('[data-qa-view-full]');
    modalDefaultView = modalEl.querySelector('[data-qa-default-view]');
    modalSuccess = modalEl.querySelector('[data-qa-success]');
    modalSuccessImage = modalEl.querySelector('[data-qa-success-image]');
    modalSuccessTitle = modalEl.querySelector('[data-qa-success-title]');
    modalSuccessPrice = modalEl.querySelector('[data-qa-success-price]');
    modalSuccessVariant = modalEl.querySelector('[data-qa-success-variant]');
    modalSuccessSubtotal = modalEl.querySelector('[data-qa-success-subtotal]');

    modalEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) closeModal();
      if (e.target.closest('[data-qa-size-guide]')) {
        openSizeChartForProduct();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl.getAttribute('data-open') === 'true') closeModal();
    });

    var qtyMinus = modalEl.querySelector('[data-qa-qty-minus]');
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      modalQty.value = Math.max(1, (parseInt(modalQty.value, 10) || 1) - 1);
    });
    var qtyPlus = modalEl.querySelector('[data-qa-qty-plus]');
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      modalQty.value = (parseInt(modalQty.value, 10) || 1) + 1;
    });
    if (modalQty && modalQty.type !== 'hidden') modalQty.addEventListener('change', function () {
      modalQty.value = Math.max(1, parseInt(modalQty.value, 10) || 1);
    });


    modalAdd.addEventListener('click', function () {
      triggerAdd(modalAdd, modalQty, modalAddLabel, modalAddSep, modalAddPrice);
    });
  }

  function triggerAdd(btn, qtyEl, labelEl, sepEl, priceEl) {
    var variantId = modalAdd.getAttribute('data-current-variant');
    if (!variantId || modalAdd.disabled || btn.classList.contains('is-adding')) return;
    var qty = Math.max(1, parseInt(qtyEl ? qtyEl.value : 1, 10) || 1);
    btn.classList.add('is-adding');
    var prevPrice = priceEl ? priceEl.textContent : '';
    var animDone = false;
    var cartResult = null;
    var cartError = null;
    setTimeout(function () {
      btn.classList.remove('is-adding');
      animDone = true;
      if (cartResult !== null) showSuccessView(cartResult);
      if (cartError !== null) {
        if (labelEl) labelEl.textContent = 'Try again';
        if (priceEl) priceEl.textContent = prevPrice;
        if (sepEl) sepEl.style.display = prevPrice ? '' : 'none';
      }
    }, 1150);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('curash:cart:add'));
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }).then(function (cart) {
      if (animDone) showSuccessView(cart);
      else cartResult = cart;
    }).catch(function (err) {
      console.warn('[QuickAdd] add to cart error:', err);
      if (animDone) {
        if (labelEl) labelEl.textContent = 'Try again';
        if (priceEl) priceEl.textContent = prevPrice;
        if (sepEl) sepEl.style.display = prevPrice ? '' : 'none';
      } else {
        cartError = err;
      }
    });
  }

  function showSuccessView(cart) {
    if (!modalSuccess || !modalDefaultView || !modalProduct) return;
    var current = findVariant(modalProduct, modalSelected);

    // Use the current primary image (reflects selected color)
    modalSuccessImage.src = modalImage.src || '';
    modalSuccessImage.alt = modalProduct.title || '';

    modalSuccessTitle.textContent = modalProduct.title || '';
    modalSuccessPrice.textContent = current ? formatMoney(current.price) : '';

    // Variant summary: "Pink / S"
    var parts = [];
    (modalProduct.options || []).forEach(function (optName) {
      var val = modalSelected[optName];
      if (val) parts.push(val);
    });
    modalSuccessVariant.textContent = parts.join(' / ');

    // Cart subtotal
    if (modalSuccessSubtotal) {
      modalSuccessSubtotal.textContent = (cart && cart.total_price != null)
        ? formatMoney(cart.total_price)
        : (current ? formatMoney(current.price) : '');
    }

    // Switch views
    modalDefaultView.hidden = true;
    modalSuccess.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRefs);
  } else {
    initRefs();
  }

  // Expose the (comprehensive) colour map so product cards, wishlist, etc. all
  // paint swatches from a single source of truth. Falls back to a neutral grey
  // for unknown names instead of leaving the swatch empty/white.
  window.CurashQuickAdd = {
    open: openModal,
    close: closeModal,
    _colorHex: function (name) {
      var hex = colorHex(name);
      return hex === '' ? '#E5E5E5' : hex;
    }
  };
})();
